import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './ComplianceReviewsCard.module.css'

interface ComplianceReviewsCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function ComplianceReviewsCard({ score = 0, maxScore = 0, status }: ComplianceReviewsCardProps) {

    const setMessage = () => {

        if (status === 'COMPLETO') {
            return (
                <div className='margin-top-20'>
                    Calendário de manutenções <span className='text-bold'>em dia!</span>
                </div>
            )
        } else if (status === 'INCOMPLETO') {
            return (
                <div className='margin-top-20'>
                    Existem manutenções <span className='text-bold'>atrasadas</span> ou <span className='text-bold'>fora da janela estipulada</span>.
                </div>
            )
        }
    }

    return (
        <StatsWidgets className={styles['fix-card-height']}>
            <StatsWidget className='shadow-default'>
                <StatsWidget.Header>Cumprimento de Calendário</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                <div style={{ fontSize: 40 }}>
                                    <span className={styles["current-score"]}>{score}</span>
                                    <span className={styles["total-score"]}>/ {maxScore}</span>
                                </div>
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                   null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}